import { render, staticRenderFns } from "./LTextarea.vue?vue&type=template&id=71ed2489&"
import script from "./LTextarea.vue?vue&type=script&lang=js&"
export * from "./LTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports